import { render, staticRenderFns } from "./SignOverlay.vue?vue&type=template&id=6747473c&scoped=true&"
import script from "./SignOverlay.vue?vue&type=script&lang=js&"
export * from "./SignOverlay.vue?vue&type=script&lang=js&"
import style0 from "./SignOverlay.vue?vue&type=style&index=0&id=6747473c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6747473c",
  null
  
)

export default component.exports